@if (customBundle) {
  <app-custom-bundle-form
    [name]="customBundle?.name"
    [bundledTests]="customBundle?.test_descriptions"
    action="{{ 'view' | translate }}"
    [isDisabled]="true"
    (close)="close($event)">
  </app-custom-bundle-form>
}
